// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6c423073","703":"c6452b5f"}[chunkId] + ".chunk.js";
};